import {
  Grid,
  Typography,
  TextField,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputLabel,
  Backdrop,
  CircularProgress,
  Button,
  Select,
  MenuItem,
  MuiThemeProvider,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Tooltip,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  FormGroup,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import useStyles from "../../themes/style.js";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import moment from "moment";
import { Controller } from "react-hook-form";
import { useNotification } from "../../hooks/useNotification.js";
import { Autocomplete } from "@material-ui/lab";
import { customTheme } from "../../components/Layout/muiTheme.js";
import { useLocation } from "react-router-dom";
import PageTitle from "../../components/PageTitle/PageTitle.js";
import { useHistory } from "react-router-dom";
import { IoAdd, IoAddCircle, IoRemove } from "react-icons/io5";
import { IoMdCheckmark } from "react-icons/io";
import { MdModeEdit } from "react-icons/md";

const dividerClass = {
  marginTop: "20px",
};

const bloodGroups = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];

const maritalStatusList = [
  "Single",
  "Married",
  "Divorced",
  "Widowed",
  "Separated",
  "Prefer not to say",
];

const EditEmployeeUser = ({ handleModalClose }) => {
  const classes = useStyles();
  const history = useHistory();
  const [loader, setLoader] = useState(false);

  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const location = useLocation();
  const userId = new URLSearchParams(location.search).get("userId");
  const employeeName = new URLSearchParams(location.search).get("fullName");

  const handleNotificationCall = useNotification();

  const [userName, setUserName] = useState([]);
  const [employeeEdit, setEmployeeEdit] = useState({
    id: "",
    email: "",
    firstName: "",
    lastName: "",
    mobile: "",
    isActive: "",
    employeeId: "",

    roleName: "",
    dob: "",
    gender: "",
    bloodGroup: "",
    maritalStatus: "",
    spouseName: "",
    joinningDate: "",
    personalEmail: "",
    fatherName: "",
    motherName: "",
    emergencyMobile: "",
    emergencyContactRelation: "",
    currentAddress: "",
    permanentAddress: "",
    totalExperience: "",

    //office-details
    empId: "",
    designation: "",
    department: "",
    companyBranchName: "",
    isContract: false,
    contractClientName: "",
    employee_contracts: [],
    DirectReportingTo: "",
    DotReportingTo: "",

    //bank-details
    aadhaarNumber: "",
    panNumber: "",
    pfNumber: "",
    uanNumber: "",
    esiNumber: "",
    bankName: "",
    bankAccountNumber: "",
    bankIfscCode: "",

    //salary-details
    basicSalary: "",
    specialAllowance: "",
    shiftAllowance: "",
    otherAllowance: "",
  });

  const [showAddField, setShowAddField] = useState(false);
  const [editContractData, setEditContractData] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required("Email is required")
      .email("Email must be a Valid Email Address"),
    firstName: Yup.string()
      .max(255)
      .required("First Name is required")
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "First Name be Alphanumeric",
      }),
    lastName: Yup.string()
      .max(255)
      .required("Last Name is required")
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "Last Name be Alphanumeric",
      }),
    mobile: Yup.string()
      .required("Mobile is required")
      .min(10, "Must be exactly 10 digits")
      .max(10, "Must be exactly 10 digits"),
    roleName: Yup.string().required("User Category is required"),

    //employee schema
    dob: Yup.string(),
    gender: Yup.string().nullable().required("Gender is required"),
    bloodGroup: Yup.string().nullable(),
    maritalStatus: Yup.string().nullable(),
    spouseName: Yup.string().nullable(),
    joinningDate: Yup.string()
      .required("Date of joining is required")
      .nullable(),
    personalEmail: Yup.string()
      .required("Personal Email is required")
      .email("Email must be a Valid Email Address"),

    fatherName: Yup.string().required("Father Name is required"),
    motherName: Yup.string().required("Mother Name is required"),
    emergencyMobile: Yup.string()
      .required("Emergency Contact Number is required")
      .min(10, "Must be exactly 10 digits")
      .max(10, "Must be exactly 10 digits"),
    emergencyContactRelation: Yup.string(),
    currentAddress: Yup.string().required("Current Address is required"),
    permanentAddress: Yup.string().required("Permanent Address is required"),
    totalExperience: Yup.string().required(
      "Total Experience field is required",
    ),

    empId: Yup.string().nullable(),
    employeeId: Yup.string().nullable(),
    designation: Yup.string().nullable(),
    department: Yup.string().nullable(),
    companyBranchName: Yup.string().nullable(),
    DirectReportingTo: Yup.string().nullable(),
    DotReportingTo: Yup.string().nullable(),

    isContract: Yup.boolean()
      .required("This field is required")
      .oneOf([true, false], "Invalid value for isContract"),
    contractClientName: Yup.string().nullable().notRequired(),
    contractStartDate: Yup.string().when([], {
      is: () => employeeEdit.isContract === true && employeeEdit.employee_contracts.length===0,
      then: Yup.string().required("Contract Start Date is required"),
      otherwise: Yup.string(),
    }),
    contractEndDate: Yup.string().when([], {
      is: () => employeeEdit.isContract === true && employeeEdit.employee_contracts.length===0,
      then: Yup.string().required("Contract End Date is required"),
      otherwise: Yup.string(),
    }),
    contractType: Yup.string().nullable().notRequired(),
    contractDetails: Yup.string().nullable().notRequired(),

    aadhaarNumber: Yup.string().required("Aadhar Number is required"),
    panNumber: Yup.string().required("PAN Number is required"),
    pfNumber: Yup.string().nullable(),
    uanNumber: Yup.string().nullable(),
    esiNumber: Yup.string().nullable(),
    bankName: Yup.string().nullable(),
    bankAccountNumber: Yup.string().nullable(),
    bankIfscCode: Yup.string().nullable(),

    basicSalary: Yup.string().nullable(),
    specialAllowance: Yup.string().nullable(),
    shiftAllowance: Yup.string().nullable(),
    otherAllowance: Yup.string().nullable(),
  });

  const {
    register,
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      isContract: false,
    },
  });

  const contractSchema = Yup.object().shape({
    contractClientName: Yup.string().nullable().notRequired(),
    contractType: Yup.string().nullable().notRequired(),
    contractDetails: Yup.string().nullable().notRequired(),
    contractStartDate: Yup.date().required("Contract Start Date is required"),
    contractEndDate: Yup.date()
      .min(Yup.ref("contractStartDate"), "End Date cannot be before Start Date")
      .required("Contract End Date is required"),
  });

  const editContractSchema = Yup.object().shape({
    id: Yup.string().nullable().notRequired(),
    contractClientName: Yup.string().nullable().notRequired(),
    contractType: Yup.string().nullable().notRequired(),
    contractDetails: Yup.string().nullable().notRequired(),
    contractStartDate: Yup.date().required("Contract Start Date is required"),
    contractEndDate: Yup.date()
      .min(Yup.ref("contractStartDate"), "End Date cannot be before Start Date")
      .required("Contract End Date is required"),
  });

  const {
    register: contractRegister,
    handleSubmit: contractHandleSubmit,
    resetField: contractResetField,
    formState: { errors: contractErrors },
  } = useForm({
    resolver: yupResolver(contractSchema),
  });

  const {
    register: editContractRegister,
    handleSubmit: editContractHandleSubmit,
    setValue: editContractSetValue,
    resetField: editContractResetField,
    formState: { errors: editContractErrors },
  } = useForm({
    resolver: yupResolver(editContractSchema),
  });

  const handleEditContractData = (item) => {
    setEditContractData(true);
    editContractSetValue("id", item.id);
    editContractSetValue("contractType", item.contractType);
    editContractSetValue(
      "contractStartDate",
      moment(item.contractStartDate).format("YYYY-MM-DD"),
    );
    editContractSetValue(
      "contractEndDate",
      moment(item.contractEndDate).format("YYYY-MM-DD"),
    );
    editContractSetValue("contractDetails", item.contractDetails);
  };

  const handleCloseContractModalEdit = () => {
    setEditContractData(false);
    editContractResetField("id");
    editContractResetField("contractType");
    editContractResetField("contractStartDate");
    editContractResetField("contractEndDate");
    editContractResetField("contractDetails");
  };

  useEffect(() => {
    fetchEmployeeDetails();
    getAllUserList();
  }, []);

  const fetchEmployeeDetails = async () => {
    setLoader(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}employee/getUserEmployee?userId=${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        const responseData = response.data.data;

        const salaryDetail = responseData?.salary_detail;
        const employeeContracts = responseData?.employee_contracts;
        const employee = responseData?.employee
          ? responseData?.employee
          : responseData.recruiter;

        setValue("email", responseData.email);
        setValue("firstName", employee.firstName);
        setValue("lastName", employee.lastName);
        setValue("mobile", employee.mobile);
        setValue("roleName", responseData.roleName);

        setValue("designation", responseData.designation);
        setValue("department", responseData.department);

        setValue("DirectReportingTo", responseData.DirectReportingTo);
        setValue("DotReportingTo", responseData.DotReportingTo);
        setValue("companyBranchName", employee.companyBranchName);
        setValue("currentAddress", employee.currentAddress);
        setValue("dob", employee.dob);
        setValue("emergencyContactRelation", employee.emergencyContactRelation);
        setValue("emergencyMobile", employee.emergencyMobile);
        setValue(
          "empId",
          employee.empId
            ? employee.empId
            : employee.employeeId
            ? employee.employeeId
            : "",
        );
        setValue("fatherName", employee.fatherName);
        setValue("bloodGroup", employee.bloodGroup);
        setValue("gender", employee.gender);
        setValue(
          "joinningDate",
          moment(employee.joinningDate).format("YYYY-MM-DD"),
        );
        setValue("maritalStatus", employee.maritalStatus);
        setValue("mobile", employee.mobile);
        setValue("motherName", employee.motherName);
        setValue("permanentAddress", employee.permanentAddress);
        setValue("personalEmail", employee.personalEmail);
        setValue("spouseName", employee.spouseName);
        setValue("totalExperience", employee.totalExperience);

        //salary-detail
        setValue("aadhaarNumber", salaryDetail.aadhaarNumber);
        setValue("bankAccountNumber", salaryDetail.bankAccountNumber);
        setValue("bankIfscCode", salaryDetail.bankIfscCode);
        setValue("bankName", salaryDetail.bankName);
        setValue("basicSalary", salaryDetail.basicSalary);
        setValue("contractClientName", salaryDetail.contractClientName);
        setValue("esiNumber", salaryDetail.esiNumber);
        setValue("isContract", salaryDetail.isContract);
        setValue("otherAllowance", salaryDetail.otherAllowance);
        setValue("panNumber", salaryDetail.panNumber);
        setValue("pfNumber", salaryDetail.pfNumber);
        setValue("shiftAllowance", salaryDetail.shiftAllowance);
        setValue("specialAllowance", salaryDetail.specialAllowance);
        setValue("uanNumber", salaryDetail.uanNumber);

        setEmployeeEdit({
          id: "",
          email: responseData.email,
          firstName: responseData?.recruiter?.firstName,
          lastName: responseData?.recruiter?.lastName,
          mobile: "",
          isActive: "",
          employeeId: "",

          roleName: "",
          dob: "",
          gender: "",
          bloodGroup: "",
          maritalStatus: "",
          spouseName: "",
          joinningDate: "",
          personalEmail: "",
          fatherName: "",
          motherName: "",
          emergencyMobile: "",
          emergencyContactRelation: "",
          currentAddress: "",
          permanentAddress: "",
          totalExperience: "",

          //office-details
          empId: "",
          designation: "",
          department: "",
          companyBranchName: "",
          isContract: salaryDetail.isContract,
          contractClientName: "",
          employee_contracts: employeeContracts,
          DirectReportingTo: "",
          DotReportingTo: "",

          //bank-details
          aadhaarNumber: "",
          panNumber: "",
          pfNumber: "",
          uanNumber: "",
          esiNumber: "",
          bankName: "",
          bankAccountNumber: "",
          bankIfscCode: "",

          //salary-details
          basicSalary: "",
          specialAllowance: "",
          shiftAllowance: "",
          otherAllowance: "",
        });
        console.log(responseData);
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const getAllUserList = async () => {
    try {
      setLoader(true);

      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}auth/getAllUserList`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        const responseData = response.data.data;
        const userList = responseData.filter((item) => item.fullName !== null);
        const userExcludingList = userList.filter((item) => item.id !== userId);
        // console.log(userExcludingList)
        setUserName(userExcludingList);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const handleEditEmployee = async (values) => {
    setLoader(true);

   const contractDurationData = {
      contractStartDate: values.contractStartDate,
      contractEndDate: values.contractEndDate,
      contractType: values.contractType,
      contractDetails: values.contractDetails,
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/editUser`,
        {
          ...values,
          id: userId,
          empId: values.empId,
          employeeId: values.empId,
          contractDurations: employeeEdit.isContract === true && employeeEdit.employee_contracts.length===0 ? contractDurationData : null
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        history.push("/app/employees");
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const handleEditEmployeeContract = async (values) => {
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}employee/editEmployeeContract`,
        {
          userId,
          ...values,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        handleCloseContractModalEdit();
        fetchEmployeeDetails();
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const handleAddContractDetails = async (values) => {
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}employee/addEmployeeContract`,
        {
          userId,
          ...values,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        resetExtendContractPeriod();
        fetchEmployeeDetails();
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const resetExtendContractPeriod = () => {
    setShowAddField(false);
    contractResetField("contractType");
    contractResetField("contractStartDate");
    contractResetField("contractEndDate");
    contractResetField("contractDetails");
  };

  return (
    <MuiThemeProvider theme={customTheme}>
      <div
        className={classes.flexCenter}
        style={{ padding: "30px 0px", width: "100%" }}
      >
        <div className="details-form-card employee-details-card">
          <div className="details-form-header">
            <span className="icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ width: "1.3rem", height: "1.3rem" }}
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m3.99 16.854-1.314 3.504a.75.75 0 0 0 .966.965l3.503-1.314a3 3 0 0 0 1.068-.687L18.36 9.175s-.354-1.061-1.414-2.122c-1.06-1.06-2.122-1.414-2.122-1.414L4.677 15.786a3 3 0 0 0-.687 1.068zm12.249-12.63 1.383-1.383c.248-.248.579-.406.925-.348.487.08 1.232.322 1.934 1.025.703.703.945 1.447 1.025 1.934.058.346-.1.677-.348.925L19.774 7.76s-.353-1.06-1.414-2.12c-1.06-1.062-2.121-1.415-2.121-1.415z"
                    fill="#ffffff"
                  ></path>
                </g>
              </svg>
            </span>
            <p className="alert">{`Edit Details for ${employeeName}`}</p>
          </div>
          <div>
            <form
              onSubmit={handleSubmit(handleEditEmployee)}
              autoComplete="off"
              noValidate
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  marginTop: "20px",
                }}
              >
                <Typography variant="body2">Personal Details</Typography>
                <Grid container direction="row" spacing={2}>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="firstName">
                      First Name
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter First Name"
                        id="firstName"
                        name="firstName"
                        {...register("firstName")}
                        error={errors.firstName ? true : false}
                        defaultValue={employeeEdit?.recruiter?.firstName}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.firstName?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="lastName">
                      Last Name
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        size="small"
                        placeholder="Enter Last Name"
                        id="lastName"
                        name="lastName"
                        {...register("lastName")}
                        error={errors.lastName ? true : false}
                        defaultValue={employeeEdit?.recruiter?.lastName}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.lastName?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="dob">
                      Date of Birth
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        InputProps={{ disableUnderline: true }}
                        classes={{ root: classes.customTextField }}
                        size="small"
                        type="date"
                        placeholder="Select employee date of birth"
                        id="dob"
                        {...register("dob")}
                        error={errors.dob ? true : false}
                        defaultValue={employeeEdit.dob}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.dob?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="gender">
                      Gender
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <Controller
                        name="gender"
                        control={control}
                        defaultValue=""
                        render={({ field: { onChange, value } }) => (
                          <Select
                            value={value}
                            onChange={(e) => onChange(e.target.value)}
                            error={errors.gender ? true : false}
                            classes={{
                              root: classes.customSelectField,
                              icon: classes.customSelectIcon,
                            }}
                            disableUnderline
                          >
                            <MenuItem value="Male">Male</MenuItem>
                            <MenuItem value="Female">Female</MenuItem>
                            <MenuItem value="Transgender">Transgender</MenuItem>
                            <MenuItem value="Prefer not to say">
                              Prefer not to say
                            </MenuItem>
                          </Select>
                        )}
                      />
                      <Typography variant="inherit" color="error">
                        {errors.gender?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="bloodGroup">
                      Blood Group
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <Controller
                        name="bloodGroup"
                        control={control}
                        defaultValue=""
                        render={({ field: { onChange, value } }) => (
                          <Select
                            value={value}
                            onChange={(e) => onChange(e.target.value)}
                            error={errors.bloodGroup ? true : false}
                            classes={{
                              root: classes.customTextField,
                              icon: classes.customSelectIcon,
                            }}
                            disableUnderline
                          >
                            {bloodGroups.map((group) => (
                              <MenuItem key={group} value={group}>
                                {group}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />
                      <Typography variant="inherit" color="error">
                        {errors.bloodGroup?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="maritalStatus">
                      Marital Status
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <Controller
                        name="maritalStatus"
                        control={control}
                        defaultValue=""
                        render={({ field: { onChange, value } }) => (
                          <Select
                            value={value}
                            onChange={(e) => onChange(e.target.value)}
                            error={errors.maritalStatus ? true : false}
                            classes={{
                              root: classes.customTextField,
                              icon: classes.customSelectIcon,
                            }}
                            disableUnderline
                          >
                            {maritalStatusList.map((group) => (
                              <MenuItem key={group} value={group}>
                                {group}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />
                      <Typography variant="inherit" color="error">
                        {errors.maritalStatus?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="spouseName">
                      Spouse Name
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter Spouse Name"
                        name="spouseName"
                        {...register("spouseName")}
                        error={errors.spouseName ? true : false}
                        defaultValue={employeeEdit.spouseName}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.spouseName?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="mobile">
                      Contact Number
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        size="small"
                        type="number"
                        placeholder="Enter Mobile Number"
                        id="mobile"
                        name="mobile"
                        {...register("mobile")}
                        error={errors.mobile ? true : false}
                        defaultValue={employeeEdit.mobile}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.mobile?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="personalEmail">
                      Personal Email
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        size="small"
                        placeholder="Enter Persaonal Email"
                        name="personalEmail"
                        {...register("personalEmail")}
                        error={errors.personalEmail ? true : false}
                        defaultValue={employeeEdit.personalEmail}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.personalEmail?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="fatherName">
                      Father Name
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter Father Name"
                        name="fatherName"
                        {...register("fatherName")}
                        error={errors.fatherName ? true : false}
                        defaultValue={employeeEdit.fatherName}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.fatherName?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="motherName">
                      Mother Name
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        size="small"
                        placeholder="Enter Mother Name"
                        name="motherName"
                        {...register("motherName")}
                        error={errors.motherName ? true : false}
                        defaultValue={employeeEdit.motherName}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.motherName?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="emergencyMobile">
                      Emergency Contact Number
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        size="small"
                        type="number"
                        placeholder="Enter Emergency Mobile Number"
                        id="emergencyMobile"
                        name="emergencyMobile"
                        {...register("emergencyMobile")}
                        error={errors.emergencyMobile ? true : false}
                        defaultValue={employeeEdit.emergencyMobile}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.emergencyMobile?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="emergencyContactRelation">
                      Emergency Contact Name & Relationship
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        size="small"
                        placeholder="Enter Emergency Contact Name & Relationship"
                        name="emergencyContactRelation"
                        {...register("emergencyContactRelation")}
                        error={errors.emergencyContactRelation ? true : false}
                        defaultValue={employeeEdit.emergencyContactRelation}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.emergencyContactRelation?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="currentAddress">
                      Current Address
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter Current Address"
                        name="currentAddress"
                        {...register("currentAddress")}
                        error={errors.currentAddress ? true : false}
                        defaultValue={employeeEdit.currentAddress}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.currentAddress?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="permanentAddress">
                      Permanent Address
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        size="small"
                        placeholder="Enter Permanent Address"
                        name="permanentAddress"
                        {...register("permanentAddress")}
                        error={errors.permanentAddress ? true : false}
                        defaultValue={employeeEdit.permanentAddress}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.permanentAddress?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="totalExperience">
                      Total Experience (in Years)
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter Employee Total Experience"
                        name="totalExperience"
                        {...register("totalExperience")}
                        error={errors.totalExperience ? true : false}
                        defaultValue={employeeEdit.totalExperience}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.totalExperience?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                </Grid>

                <Typography variant="body2" style={dividerClass}>
                  Office Details
                </Typography>
                <Grid container direction="row" spacing={2}>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="email">
                      Official Email
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        size="small"
                        placeholder="Enter Email"
                        id="email"
                        name="email"
                        {...register("email")}
                        error={errors.email ? true : false}
                        defaultValue={employeeEdit.email}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.email?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="empId">
                      Employee ID
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        size="small"
                        type="number"
                        placeholder="Enter Employee Id"
                        id="empId"
                        name="empId"
                        {...register("empId")}
                        error={errors.employeeId ? true : false}
                        defaultValue={employeeEdit.empId}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.empId?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="companyBranchName">
                      Company Branch Name & Address
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter Company Branch Name & Address"
                        name="companyBranchName"
                        {...register("companyBranchName")}
                        error={errors.companyBranchName ? true : false}
                        defaultValue={employeeEdit.companyBranchName}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.companyBranchName?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="designation">
                      Designation
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter Employee Designation"
                        name="designation"
                        {...register("designation")}
                        error={errors.designation ? true : false}
                        defaultValue={employeeEdit.designation}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.designation?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="department">
                      Department
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        size="small"
                        placeholder="Enter Employee Department"
                        name="department"
                        {...register("department")}
                        error={errors.department ? true : false}
                        defaultValue={employeeEdit.department}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.department?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="DirectReportingTo">
                      Direct Reporting To:
                    </InputLabel>
                    <Controller
                      name="DirectReportingTo"
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          className="filterFullWidth"
                          options={userName}
                          getOptionLabel={(option) => option.fullName}
                          onChange={(event, value) =>
                            setValue(
                              "DirectReportingTo",
                              value ? value.id : null,
                            )
                          }
                          value={
                            userName.find((user) => user.id === field.value) ||
                            null // Match the value
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              label=""
                              InputLabelProps={{ shrink: true }}
                              type="text"
                            />
                          )}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="DotReportingTo">
                      Dotted Reporting To:
                    </InputLabel>
                    <Controller
                      name="DotReportingTo"
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          className="filterFullWidth"
                          options={userName}
                          getOptionLabel={(option) => option.fullName}
                          onChange={(event, value) =>
                            setValue("DotReportingTo", value ? value.id : null)
                          }
                          value={
                            userName.find((user) => user.id === field.value) ||
                            null // Match the value
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              label=""
                              InputLabelProps={{ shrink: true }}
                              type="text"
                            />
                          )}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="isContract">
                      Is a Contract with an Employer?
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <Controller
                        name="isContract"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <FormGroup row>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={value === true}
                                  onChange={() => onChange(true)}
                                />
                              }
                              label="Yes"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={value === false}
                                  onChange={() => onChange(false)}
                                />
                              }
                              label="No"
                            />
                          </FormGroup>
                        )}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.isContract?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  {watch("isContract") && (
                    <>
                      <Typography variant="body2" style={dividerClass}>
                        Contract Detail
                      </Typography>
                      {employeeEdit.employee_contracts.length === 0 ? (
                        <Grid container direction="row" spacing={2} style={{padding: "12px 0px",}}>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="contractClientName">
                              Contract Client Name
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter Contract Client Name"
                                name="contractClientName"
                                {...register("contractClientName")}
                                error={errors.contractClientName ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.contractClientName?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="contractType">
                              Contract Type
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter Contract Type"
                                name="contractType"
                                {...register("contractType")}
                                error={errors.contractType ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.contractType?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="contractDetails">
                              Contract Detail
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter Contract Client Detail"
                                name="contractDetails"
                                {...register("contractDetails")}
                                error={errors.contractDetails ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.contractDetails?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="contractStartDate">
                              Contract Start Date
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="date"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter Contract Start Date"
                                name="contractStartDate"
                                {...register("contractStartDate")}
                                error={errors.contractStartDate ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.contractStartDate?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="contractEndDate">
                              Contract End Date
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="date"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter Contract End Date"
                                name="contractEndDate"
                                {...register("contractEndDate")}
                                error={errors.contractEndDate ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.contractEndDate?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                        </Grid>
                      ) : (
                        <div
                          style={{
                            fontSize: "18px",
                            fontWeight: 500,
                            padding: "12px 0px",
                            width: "100%",
                          }}
                        >
                          <Grid item xs={12} sm={6} md={6} lg={6} style={{ width: "100%", margin: "12px 0px" }}>
                            <InputLabel shrink htmlFor="contractClientName">
                              Contract Client Name
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter Contract Client Name"
                                name="contractClientName"
                                {...register("contractClientName")}
                                error={errors.contractClientName ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.contractClientName?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <TableContainer
                            component={Paper}
                            style={{ width: "100%", margin: "12px 0px" }}
                          >
                            <Table
                              // className={classes.table}
                              aria-label="simple table"
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell align="left">Type</TableCell>
                                  <TableCell align="left">Details</TableCell>
                                  <TableCell align="right">From Date</TableCell>
                                  <TableCell align="right">To Date</TableCell>
                                  <TableCell align="center">Action</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {employeeEdit.employee_contracts.map((row) => (
                                  <TableRow
                                    style={{ background: "#fff" }}
                                    key={row.contractStartDate}
                                  >
                                    <TableCell align="left">
                                      {row.contractType}
                                    </TableCell>
                                    <TableCell align="left">
                                      {row.contractDetails}
                                    </TableCell>
                                    <TableCell align="right">
                                      {moment(row.contractStartDate).format(
                                        "DD MMMM YYYY",
                                      )}
                                    </TableCell>
                                    <TableCell align="right">
                                      {moment(row.contractEndDate).format(
                                        "DD MMMM YYYY",
                                      )}
                                    </TableCell>
                                    <TableCell align="center">
                                      <Tooltip title="Edit">
                                        <span
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            handleEditContractData(row)
                                          }
                                        >
                                          <MdModeEdit size={20} />
                                        </span>
                                      </Tooltip>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>

                          {!showAddField ? (
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              startIcon={<IoAddCircle />}
                              style={{ marginTop: "10px" }}
                              type="button"
                              onClick={() => setShowAddField(true)}
                            >
                              Extend Contract Period
                            </Button>
                          ) : (
                            <>
                              <Grid
                                container
                                direction="row"
                                spacing={2}
                                style={{ padding: "8px", marginTop: "12px" }}
                              >
                                <Grid item xs={12}>
                                  <Typography variant="p">
                                    {"Extend Contract Period"}
                                  </Typography>
                                </Grid>

                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                  <InputLabel shrink htmlFor="contractType">
                                    Contract Type
                                  </InputLabel>
                                  <FormControl className={classes.margin}>
                                    <TextField
                                      size="small"
                                      classes={{
                                        root: classes.customTextField,
                                      }}
                                      InputProps={{ disableUnderline: true }}
                                      placeholder="Enter Contract Type"
                                      name="contractType"
                                      {...contractRegister("contractType")}
                                      error={
                                        contractErrors.contractType
                                          ? true
                                          : false
                                      }
                                    />

                                    <Typography variant="inherit" color="error">
                                      {contractErrors.contractType?.message}
                                    </Typography>
                                  </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                  <InputLabel shrink htmlFor="contractDetails">
                                    Contract Detail
                                  </InputLabel>
                                  <FormControl className={classes.margin}>
                                    <TextField
                                      size="small"
                                      classes={{
                                        root: classes.customTextField,
                                      }}
                                      InputProps={{ disableUnderline: true }}
                                      placeholder="Enter Contract Client Detail"
                                      name="contractDetails"
                                      {...contractRegister("contractDetails")}
                                      error={
                                        contractErrors.contractDetails
                                          ? true
                                          : false
                                      }
                                    />

                                    <Typography variant="inherit" color="error">
                                      {contractErrors.contractDetails?.message}
                                    </Typography>
                                  </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                  <InputLabel
                                    shrink
                                    htmlFor="contractStartDate"
                                  >
                                    Contract Start Date
                                  </InputLabel>
                                  <FormControl className={classes.margin}>
                                    <TextField
                                      size="small"
                                      type="date"
                                      classes={{
                                        root: classes.customTextField,
                                      }}
                                      InputProps={{ disableUnderline: true }}
                                      placeholder="Enter Contract Start Date"
                                      name="contractStartDate"
                                      {...contractRegister("contractStartDate")}
                                      error={
                                        contractErrors.contractStartDate
                                          ? true
                                          : false
                                      }
                                    />

                                    <Typography variant="inherit" color="error">
                                      {
                                        contractErrors.contractStartDate
                                          ?.message
                                      }
                                    </Typography>
                                  </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                  <InputLabel shrink htmlFor="contractEndDate">
                                    Contract End Date
                                  </InputLabel>
                                  <FormControl className={classes.margin}>
                                    <TextField
                                      size="small"
                                      type="date"
                                      classes={{
                                        root: classes.customTextField,
                                      }}
                                      InputProps={{ disableUnderline: true }}
                                      placeholder="Enter Contract End Date"
                                      name="contractEndDate"
                                      {...contractRegister("contractEndDate")}
                                      error={
                                        contractErrors.contractEndDate
                                          ? true
                                          : false
                                      }
                                    />

                                    <Typography variant="inherit" color="error">
                                      {contractErrors.contractEndDate?.message}
                                    </Typography>
                                  </FormControl>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  style={{ display: "flex", gap: "10px" }}
                                >
                                  <Button
                                    variant="contained"
                                    size="small"
                                    startIcon={<IoMdCheckmark />}
                                    className={classes.green}
                                    style={{ marginTop: "10px" }}
                                    type="button"
                                    onClick={contractHandleSubmit(
                                      handleAddContractDetails,
                                    )}
                                  >
                                    Save
                                  </Button>
                                  <Button
                                    variant="contained"
                                    color="default"
                                    size="small"
                                    style={{ marginTop: "10px" }}
                                    type="button"
                                    onClick={resetExtendContractPeriod}
                                  >
                                    Cancel
                                  </Button>
                                </Grid>
                              </Grid>
                            </>
                          )}
                          {/* {fields.map((field, index) => (
                        <Grid
                          key={field.id}
                          container
                          direction="row"
                          spacing={2}
                          style={{ padding: "8px" }}
                        >
                          <Grid item xs={12}>
                            <Typography variant="p">
                              {index == 0
                                ? "Contract Period"
                                : "Extend Contract Period"}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6}>
                            <InputLabel
                              shrink
                              htmlFor={`contractDurations.${index}.contractClientName`}
                            >
                              Contract Client Name
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="text"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Contract From Date"
                                name={`contractDurations.${index}.contractClientName`}
                                {...register(
                                  `contractDurations.${index}.contractClientName`,
                                )}
                                defaultValue={field.contractClientName}
                                error={
                                  errors.contractDurations?.[index]
                                    ?.contractClientName
                                    ? true
                                    : false
                                }
                              />

                              <Typography variant="inherit" color="error">
                                {
                                  errors.contractDurations?.[index]
                                    ?.contractClientName?.message
                                }
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6}>
                            <InputLabel
                              shrink
                              htmlFor={`contractDurations.${index}.contractType`}
                            >
                              Contract Type
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="text"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Contract From Date"
                                name={`contractDurations.${index}.contractType`}
                                {...register(
                                  `contractDurations.${index}.contractType`,
                                )}
                                defaultValue={field.contractType}
                                error={
                                  errors.contractDurations?.[index]
                                    ?.contractType
                                    ? true
                                    : false
                                }
                              />

                              <Typography variant="inherit" color="error">
                                {
                                  errors.contractDurations?.[index]
                                    ?.contractType?.message
                                }
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6}>
                            <InputLabel
                              shrink
                              htmlFor={`contractDurations.${index}.contractType`}
                            >
                              Contract Type
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="text"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Contract From Date"
                                name={`contractDurations.${index}.contractType`}
                                {...register(
                                  `contractDurations.${index}.contractType`,
                                )}
                                defaultValue={field.contractType}
                                error={
                                  errors.contractDurations?.[index]
                                    ?.contractType
                                    ? true
                                    : false
                                }
                              />

                              <Typography variant="inherit" color="error">
                                {
                                  errors.contractDurations?.[index]
                                    ?.contractType?.message
                                }
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6}>
                            <InputLabel
                              shrink
                              htmlFor={`contractDurations.${index}.contractDetails`}
                            >
                              Contract Detail
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="date"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Contract From Date"
                                name={`contractDurations.${index}.contractDetails`}
                                {...register(
                                  `contractDurations.${index}.contractDetails`,
                                )}
                                defaultValue={field.contractDetails}
                                error={
                                  errors.contractDurations?.[index]
                                    ?.contractDetails
                                    ? true
                                    : false
                                }
                              />

                              <Typography variant="inherit" color="error">
                                {
                                  errors.contractDurations?.[index]
                                    ?.contractDetails?.message
                                }
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6}>
                            <InputLabel shrink htmlFor="contractEndDate">
                              To Date
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="date"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Contract To Date"
                                name="contractEndDate"
                                {...register(
                                  `contractDurations.${index}.contractEndDate`,
                                )}
                                defaultValue={field.contractEndDate}
                                error={
                                  errors.contractDurations?.[index]
                                    ?.contractEndDate
                                    ? true
                                    : false
                                }
                              />

                              <Typography variant="inherit" color="error">
                                {
                                  errors.contractDurations?.[index]
                                    ?.contractEndDate?.message
                                }
                              </Typography>
                            </FormControl>
                          </Grid>
                          <div className="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                            {showAddField && (
                              <IoAdd
                                onClick={() => {
                                  append({
                                    contractClientName: "",
                                    contractType: "",
                                    contractDetails: "",
                                    contractStartDate: moment(
                                      new Date(),
                                    ).format("YYYY-MM-DD"),
                                    contractEndDate: moment(new Date()).format(
                                      "YYYY-MM-DD",
                                    ),
                                  });
                                  setShowAddField(false);
                                }}
                                size={26}
                                color="green"
                              />
                            )}
                            {index > 0 && (
                              <IoRemove
                                onClick={() => {
                                  remove(index);
                                  setShowAddField(true);
                                }}
                                size={26}
                                color="red"
                              />
                            )}
                          </div>
                        </Grid>
                      ))} */}

                          {/* <Grid item xs={12} sm={6} md={6} lg={6}>
                        <InputLabel shrink htmlFor="contractPeriod">
                          Contract Period
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            size="small"
                            classes={{ root: classes.customTextField }}
                            InputProps={{ disableUnderline: true }}
                            placeholder="Enter Contract Period"
                            name="contractPeriod"
                            {...register("contractPeriod")}
                            error={errors.contractPeriod ? true : false}
                            defaultValue={employeeEdit.contractPeriod}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.contractPeriod?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <InputLabel shrink htmlFor="contractClientName">
                          Contract Client Name
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            size="small"
                            classes={{ root: classes.customTextField }}
                            InputProps={{ disableUnderline: true }}
                            placeholder="Enter Contract Client Name"
                            name="contractClientName"
                            {...register("contractClientName")}
                            error={errors.contractClientName ? true : false}
                            defaultValue={employeeEdit.contractClientName}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.contractClientName?.message}
                          </Typography>
                        </FormControl>
                      </Grid> */}
                        </div>
                      )}
                    </>
                  )}
                </Grid>

                <Typography variant="body2" style={dividerClass}>
                  KYC Details
                </Typography>
                <Grid container direction="row" spacing={2}>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="aadhaarNumber">
                      Aadhaar Number
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        size="small"
                        placeholder="Enter Aadhaar Number"
                        name="aadhaarNumber"
                        {...register("aadhaarNumber")}
                        error={errors.aadhaarNumber ? true : false}
                        defaultValue={employeeEdit.aadhaarNumber}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.aadhaarNumber?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="panNumber">
                      PAN Number
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter PAN Number"
                        name="panNumber"
                        {...register("panNumber")}
                        error={errors.panNumber ? true : false}
                        defaultValue={employeeEdit.panNumber}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.panNumber?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="uanNumber">
                      UAN Number
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter UAN Number"
                        name="uanNumber"
                        {...register("uanNumber")}
                        error={errors.uanNumber ? true : false}
                        defaultValue={employeeEdit.uanNumber}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.uanNumber?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="esiNumber">
                      ESI Number
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter ESI Number"
                        name="esiNumber"
                        {...register("esiNumber")}
                        error={errors.esiNumber ? true : false}
                        defaultValue={employeeEdit.esiNumber}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.esiNumber?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="pfNumber">
                      PF Number
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter PF Number"
                        name="pfNumber"
                        {...register("pfNumber")}
                        error={errors.pfNumber ? true : false}
                        defaultValue={employeeEdit.pfNumber}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.pfNumber?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="bankName">
                      Bank Name
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter Bank Name"
                        name="bankName"
                        {...register("bankName")}
                        error={errors.bankName ? true : false}
                        defaultValue={employeeEdit.bankName}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.bankName?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="bankAccountNumber">
                      Bank Account Number
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter Bank Account Number"
                        name="bankAccountNumber"
                        {...register("bankAccountNumber")}
                        error={errors.bankAccountNumber ? true : false}
                        defaultValue={employeeEdit.bankAccountNumber}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.bankAccountNumber?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="bankIfscCode">
                      Bank IFSC Code
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter Bank IfscCode"
                        name="bankIfscCode"
                        {...register("bankIfscCode")}
                        error={errors.bankIfscCode ? true : false}
                        defaultValue={employeeEdit.bankIfscCode}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.bankIfscCode?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                </Grid>

                <Typography variant="body2" style={dividerClass}>
                  Payslip Details
                </Typography>
                <Grid container direction="row" spacing={2}>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="basicSalary">
                      Basic Salary
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        type="number"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter Basic Salary"
                        name="basicSalary"
                        {...register("basicSalary")}
                        error={errors.basicSalary ? true : false}
                        defaultValue={employeeEdit.basicSalary}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.basicSalary?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="specialAllowance">
                      Special Allowance
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        type="number"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter Special Allowance"
                        name="specialAllowance"
                        {...register("specialAllowance")}
                        error={errors.specialAllowance ? true : false}
                        defaultValue={employeeEdit.specialAllowance}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.specialAllowance?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="shiftAllowance">
                      Shift Allowance
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        type="number"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter Shift Allowance"
                        name="shiftAllowance"
                        {...register("shiftAllowance")}
                        error={errors.shiftAllowance ? true : false}
                        defaultValue={employeeEdit.shiftAllowance}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.shiftAllowance?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                </Grid>
              </div>
              <Grid
                container
                direction="row"
                spacing={2}
                style={{
                  padding: "24px 10px",
                  display: "flex",
                  gap: "20px",
                }}
              >
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={() => history.push("/app/employees")}
                  style={{ flex: 1 }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  style={{ flex: 1 }}
                  type="submit"
                >
                  Save
                </Button>
              </Grid>
            </form>
          </div>
        </div>
      </div>

      {/* <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title={`Edit Details for ${employeeName} `} />
        </Grid>
      </Grid>

      <Container maxWidth="lg">
        <Grid container direction="row" spacing={2}>
          <Grid></Grid>
        </Grid>
      </Container> */}

      <Dialog
        width="xs"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
        open={editContractData}
        onClose={handleCloseContractModalEdit}
      >
        <DialogContent>
          <form onSubmit={editContractHandleSubmit(handleEditEmployeeContract)}>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12}>
                <p style={{ fontSize: "18px", fontWeight: 600, margin: 0 }}>
                  Edit Contract Detail
                </p>
              </Grid>
              <Grid item xs={12}>
                <InputLabel shrink htmlFor="contractType">
                  Contract Type
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    size="small"
                    classes={{ root: classes.customTextField }}
                    InputProps={{ disableUnderline: true }}
                    placeholder="Enter Contract Type"
                    name="contractType"
                    {...editContractRegister("contractType")}
                    error={editContractErrors.contractType ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {editContractErrors.contractType?.message}
                  </Typography>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <InputLabel shrink htmlFor="contractDetails">
                  Contract Detail
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    size="small"
                    classes={{ root: classes.customTextField }}
                    InputProps={{ disableUnderline: true }}
                    placeholder="Enter Contract Client Detail"
                    name="contractDetails"
                    {...editContractRegister("contractDetails")}
                    error={editContractErrors.contractDetails ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {editContractErrors.contractDetails?.message}
                  </Typography>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <InputLabel shrink htmlFor="contractStartDate">
                  Contract Start Date
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    size="small"
                    type="date"
                    classes={{ root: classes.customTextField }}
                    InputProps={{ disableUnderline: true }}
                    placeholder="Enter Contract Start Date"
                    name="contractStartDate"
                    {...editContractRegister("contractStartDate")}
                    error={editContractErrors.contractStartDate ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {editContractErrors.contractStartDate?.message}
                  </Typography>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <InputLabel shrink htmlFor="contractEndDate">
                  Contract End Date
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    size="small"
                    type="date"
                    classes={{ root: classes.customTextField }}
                    InputProps={{ disableUnderline: true }}
                    placeholder="Enter Contract End Date"
                    name="contractEndDate"
                    {...editContractRegister("contractEndDate")}
                    error={editContractErrors.contractEndDate ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {editContractErrors.contractEndDate?.message}
                  </Typography>
                </FormControl>
              </Grid>
              <Button
                variant="contained"
                size="small"
                color="secondary"
                onClick={() => handleCloseContractModalEdit()}
                style={{ flex: 1, margin: "0px 6px" }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ flex: 1, margin: "0px 6px" }}
                type="submit"
              >
                Save
              </Button>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </MuiThemeProvider>
  );
};

export default EditEmployeeUser;
